module.exports = __webpack_public_path__ + "img/LP_White.b57654e0.svg";